export const rawCeremonies = {
  "1": {
    name: "Open a window. Take a deep breath. Relax your shoulders, relax your tongue. \n\nThink of one word that represents your intention today. How do you want to feel during your trip? \n\nThink of a time when you felt that way before. Hold that feeling in your heart. \n\nSet your intention for the trip.",
    withWhom: ["myself"],
    kind: "intention",
    id: "1",
  },
  "2": {
    name: 'Each pick one word or a phrase (intention) you want to resonate during the rest of your day.\n\nBring your attention to something in your life or from your memories that makes you feel or think about that word.\n\nEach share that word or phrase (and, if you like, the thing which has made you feel it).\n\nNow take turns to cheer to each intention. Each person says their own intention (e.g. Me: "to curiosity!") and the rest repeat (All: "to curiosity!")',
    withWhom: ["friends"],
    kind: "intention",
    id: "2",
  },
  "3": {
    name: "Anyone can veto any activity, zero judgement at all times.\n\nAnyone is welcome to exit any activity, be alone if you like, not alone if you like\n\nBest intentions will be assumed in all cases\n\nCheck in with each other a few times throughout the experience. Are you physically comfortable? Do you need food, water or a bathroom break? How are you feeling emotionally? Consider setting gentle alarms to remind you to check in.",
    withWhom: ["friends"],
    kind: "ground rules",
    id: "3",
  },
  "4": {
    name: "Zero judgement towards yourself. Everything is acceptable. You are a human.\n\nAsking for help takes courage. Call a friend if you need to.\n\nIt's ok not to do all the activities you've planned. There will be other trips.\n\nCheck in with each yourself times throughout the experience. Are you physically comfortable? Do you need food, water or a bathroom break? How are you feeling emotionally? Consider setting gentle alarms to remind you to check in.",
    withWhom: ["myself"],
    kind: "ground rules",
    id: "4",
  },
  "5": {
    name: 'Spend a minute thinking about the following question:\n\n"What is the ritual that would summon you?"\n\nShare the answer if you like, but a full/satisfying answer may take more time. See if this pops up during the trip.\n\nAlso interesting to think about, for yourself or for each other: "the purpose for which you would be summoned"',
    withWhom: ["friends"],
    kind: "ritual",
    id: "5",
  },
  "6": {
    name: 'Spend a minute thinking about the following question:\n\n"What is the ritual that would summon you?"\n\nA full/satisfying answer may take more time. See if this pops up during the trip.\n\nAlso interesting to think about "the purpose" for which you would be summoned.',
    withWhom: ["myself"],
    kind: "ritual",
    id: "6",
  },
  "7": {
    name: "Take a minute to observe your physical environment. Pick an object and acknowledge its color, texture, and location. Note how you feel.",
    withWhom: ["myself"],
    kind: "ritual",
    id: "7",
  },
  "8": {
    name: "Take a minute to observe your physical environment. Pick an object and share its color, texture, and location. Note and share how you feel.",
    withWhom: ["friends"],
    kind: "ritual",
    id: "8",
  },
  "9": {
    name: "Pick one space to be your space, go there if you need a moment during your trip. You can also go there for no reason at all.",
    withWhom: ["friends", "myself"],
    kind: "ritual",
    id: "9",
  },
  "10": {
    name: "Everyone writes one short sentence on a scrap of piece of paper for each person including themselves. It could be anything: a question, an observation, a lyric, a thought. Fold each note and give it to the recipient. Each person places their notes in their designated space to look at later.",
    withWhom: ["friends"],
    kind: "ritual",
    id: "10",
  },
  "11": {
    name: "Pick an object or a belonging and grant it with a special power. Consider making this special power related to your intention.",
    withWhom: ["friends", "myself"],
    kind: "ritual",
    id: "11",
  },
  "12": {
    name: 'Everyone takes turns introducing themselves. "Hi, my name is ____". All the others great them at once: "Hi, ___!"',
    withWhom: ["friends"],
    kind: "ritual",
    id: "12",
  },
  "13": {
    name: "Think of two aspects you want to contribute to the trip. They could be a feeling, a concept, an activity, an outcome. Write them down on pieces of scrap paper. Collect all the pieces of paper in one place and mix them up. Each person grabs two of the pieces of paper. \n\nMake each person a drink. It could be any drink including water. Pick one of the words to contribute to someone else's trip. Dip the corner of the piece of paper with that word into that person's drink and tell them the word. \n\nCollect all the words together and burn them (safely!)",
    withWhom: ["friends"],
    kind: "ritual",
    id: "13",
  },
  "14": {
    name: "Write down three things you are good at.",
    withWhom: ["myself", "friends"],
    kind: "ritual",
    id: "14",
  },
  "15": {
    name: "If you had to describe how you’re feeling right now as a weather pattern, what’s your forecast? Take turns sharing.",
    withWhom: ["friends"],
    kind: "ritual",
    id: "15",
  },
  "16": {
    name: "If you could know the absolute and total truth to one question, what question would you ask? Take turns sharing.",
    withWhom: ["friends"],
    kind: "ritual",
    id: "16",
  },
  "17": {
    name: "If you could know the absolute and total truth to one question, what question would you ask? Write it down.",
    withWhom: ["myself"],
    kind: "ritual",
    id: "17",
  },
  "18": {
    name: "Think of a fictional world would you most like to live in. Share one thing that would be part of your everyday routine in that world.\n\n",
    withWhom: ["friends"],
    kind: "ritual",
    id: "18",
  },
  "19": {
    name: "Sit upright and close your eyes. Take a deep breath. Think of the last time you felt unbounded optimism. Keep that feeling.",
    withWhom: ["myself"],
    kind: "ritual",
    id: "19",
  },
  "20": {
    name: "What was the first thought you had waking up today? Do you want to keep that thought for your trip? If it no longer serves you, throw that thought out.",
    withWhom: ["friends", "myself"],
    kind: "ritual",
    id: "20",
  },
}

export const withWhom = ["myself", "friends"]
